/*------- accordion --------------------------*/

$(function(){
	$('.js-acc-cnt').hide();
	$('.js-acc-btn').click(function(){
		var target = $(this).parents(".acc");
		var position = (target.offset().top );	
		
		$(this).next(".js-acc-cnt").slideToggle();
		$(this).parent('.acc').toggleClass("open");
		
		if($(this).hasClass('ac')){
			$('body,html').animate({scrollTop:position});
		}
		
		$(this).toggleClass("ac");
		return false;
		
	});
});


	
var ps = new PerfectScrollbar('.scroll_box');
